<template>
  <div class="methods">
    <div class="title">Convenient repayment methods</div>
    <div class="roll">
      <div class="cover_left"></div>
      <vue-seamless-scroll
        :data="listData"
        :class-option="classOption"
        class="warp"
      >
        <div class="list">
          <div class="item" v-for="(item, index) in listData" :key="index">
            <img :src="item.url" alt="">
          </div>
        </div>
      </vue-seamless-scroll>
      <div class="cover_right"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      listData: [
        {
          url: require('@/assets/Gcash.png'),
        },
        {
          url: require('@/assets/7-11.png'),
        },
        {
          url: require('@/assets/BDO.png'),
        },
        {
          url: require('@/assets/PayMaya.png'),
        },
        {
          url: require('@/assets/ShopeePay.png'),
        },
        {
          url: require('@/assets/RD.png'),
        },
        {
          url: require('@/assets/unionbank.png'),
        },
      ],
        classOption: {
          direction: 2,
          limitMoveNum: 7
        }
    };
  },
};
</script>
<style lang="scss" scoped>
.methods {
  margin-top: 201px;
  .title {
    font-family: 'Lexend_Medium';
    font-weight: 500;
    font-size: 61px;
    color: #000000;
    line-height: 81px;
    text-align: center;
  }
  .roll {
    width: 1405px;
    height: 250px;
    margin: 95px auto 0;
    position: relative;
    .cover_left {
      position: absolute;
      top: 0;
      left: 0;
      width: 200px;
      height: 250px;
      z-index: 1;
      background: linear-gradient(to right, white, rgba(255, 255, 255, 0));
    }
    .cover_right {
      position: absolute;
      top: 0;
      right: 0;
      width: 200px;
      height: 250px;
      z-index: 1;
      background: linear-gradient(to left, white, rgba(255, 255, 255, 0));
    }
  }
  .warp {
    width: 1405px;
    height: 250px;
    overflow: hidden;
    .list {
      display: flex;
    }
    .item {
      width: 250px;
      height: 250px;
      margin-right: 38px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/repaymentMethods.vue